import {
  siGithub,
  siGitlab,
  siLinear,
  siSentry,
  siStripe,
  siVercel,
  type SimpleIcon,
} from 'simple-icons';

import { Icons } from '@/assets/icons/icons';
import { cn } from '@/lib/utils';

// GitHub's and Vercel's marks are black, so they take the text colour to show in dark mode
const SERVICE_LOGOS: Record<string, { icon: SimpleIcon; brandColor: boolean }> =
  {
    GitHub: { icon: siGithub, brandColor: false },
    GitLab: { icon: siGitlab, brandColor: true },
    Linear: { icon: siLinear, brandColor: true },
    Sentry: { icon: siSentry, brandColor: true },
    Stripe: { icon: siStripe, brandColor: true },
    Vercel: { icon: siVercel, brandColor: false },
  };

/** The logo of a service that has webhook presets; a service Simple Icons lacks, such as Axiom, gets a plug. */
export function WebhookServiceLogo({
  service,
  className,
}: {
  service: string;
  className?: string;
}) {
  const logo = SERVICE_LOGOS[service];
  if (!logo) return <Icons.plugZap className={cn('shrink-0', className)} />;
  return (
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className={cn('shrink-0', className)}
      fill={logo.brandColor ? `#${logo.icon.hex}` : 'currentColor'}
    >
      <path d={logo.icon.path} />
    </svg>
  );
}
